import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  fileIcon: {
    color: token.colorTextDescription
  },
  fileName: {
    cursor: 'pointer',
    color: `${token.colorPrimary} !important`
  }
}))
